import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import type { ChatPageUiControlFragment } from '../../ChatPageContainer.generated'

export const useChatListGroupViewSelector = (
  uiControl: ChatPageUiControlFragment
) => {
  const options = computed(() =>
    [
      {
        option: {
          value: 1,
          text: 'マッチしたユーザー',
        },
        condition: uiControl.viewMatchedRooms,
        routeName: 'ownChatIndex',
      },
      {
        option: {
          value: 4,
          text: '担当ユーザー',
        },
        condition: true,
        routeName: 'assignedChatIndex',
      },
      {
        option: {
          value: 2,
          text: '企業メンバー',
        },
        condition: uiControl.viewCorporationMemberRooms,
        routeName: 'memberChatIndex',
      },
      {
        option: {
          value: 3,
          text: '支社メンバー',
        },
        condition: uiControl.viewBranchMemberRooms,
        routeName: 'memberChatIndex',
      },
    ].filter(({ condition }) => condition)
  )

  const selectorOptions = computed(() =>
    options.value.map(({ option }) => option)
  )

  const router = useRouter()
  const route = useRoute()

  const selectorValue = computed({
    get: () => {
      const currentRouteName = route.name
      if (currentRouteName == null) {
        return
      }
      return options.value.find(({ routeName }) =>
        routeName.startsWith(currentRouteName.toString())
      )?.option.value
    },
    set: newValue => {
      const nextRouteName = options.value.find(
        ({ option }) => option.value === newValue
      )?.routeName
      // eslint-disable-next-line fp/no-mutating-methods, @typescript-eslint/no-explicit-any
      void router.push({ name: nextRouteName as any })
    },
  })

  return {
    selectorOptions,
    selectorValue,
  }
}
